import { appData, getApiKey } from 'optinmonster-js-library/src/utils'
import { disableDevCookie } from 'optinmonster-js-library/src/utils/apiKey'
import state from './state'
import { dismissKeys } from '../dashboard/store/state'

disableDevCookie()

const templatePaths = [
	'templates.activeType',
	// 'templates.activeTemplate',
	// 'templates.sort',
	// 'templates.search',
	'templates.filterOptions',
	// 'templates.filters',
]

const persistedPaths = [
	'visits',
	'wizard',
	'plugins',
]
dismissKeys.forEach(k => {
	persistedPaths.push(`dashboard.${k}`)
})

const noAuthPaths = [
	'user.onboarding',
	...persistedPaths,
	...templatePaths,
]

const authenticatedPaths = () => {
	// Ejecting a few keys which we do not want/need persisted.
	let {

		// Don't persist `created`` as we use this to determine if user data should be fetched.
		created,
		updated,
		email,
		name,
		firstName,
		lastName,
		...userKeys
	} = state.user

	const userPaths = Object.keys(userKeys).map(k => `user.${k}`)

	templatePaths.push('templates.permittedTypes')
	const paths = [
		...persistedPaths,
		...templatePaths,
		...userPaths,
	]

	return paths
}

export default {
	key   : appData.key,
	paths : getApiKey() ? authenticatedPaths() : noAuthPaths,
}
